import React from 'react';
import { Check, BookOpen, Users, Target, Calendar, DollarSign, MessageCircle, Award, ArrowRight, AlertCircle, Clock, ShieldCheck, Sparkles } from 'lucide-react';
import { PurchasePopup } from './components/PurchasePopup';
import { TestimonialCard } from './components/TestimonialCard';
import { ImageCarousel } from './components/ImageCarousel';
import { FAQSection } from './components/FAQSection';
// Image Constants
const MAIN_IMAGE = 'https://cdn.magicpatterns.com/uploads/gszrRv1N75GwiDQw2NCHrN/COVER_PO_360.png';
const BONUS_1_IMAGE = 'https://cdn.magicpatterns.com/uploads/hywwTuJkzbufvtZh5sEBHP/BONO_1_PO_MAPA_ANUAL.png';
const BONUS_2_IMAGE = 'https://cdn.magicpatterns.com/uploads/hmRV5PRBhX9muWuoAA5XPq/BONO_2_PO_EVALUACIONES_RUBRICAS.png';
// New images for MEGAPACK carousel
const MEGAPACK_IMAGES = ['https://cdn.magicpatterns.com/uploads/fZmowXfoFMMMnpdjSca526/COVER_MEGAPACK_PROYECTOS.png', 'https://cdn.magicpatterns.com/uploads/iTQYLEeS6RgatqHkpR6sS8/COVER_TDLO360.png', 'https://cdn.magicpatterns.com/uploads/6hcq88mKMcF6U2VDGtwCzg/COVER_PO_360.png', 'https://cdn.magicpatterns.com/uploads/xckk44Pm7QrE1pPQn7NCWC/UPSELL_TEORIA_DE_LAS_ORGANIZACIONES.png', 'https://cdn.magicpatterns.com/uploads/fuEiWX7tNk6K3W52xe3xEy/ChatGPT_Image_11_ene_2026,_07_34_47_p.m..png'];
// New images for Proyecto Integrador carousel
const PROYECTO_INTEGRADOR_IMAGES = ['https://cdn.magicpatterns.com/uploads/p9P1GnxgZvusHXvNc473Au/COVER_PO_360.png', 'https://cdn.magicpatterns.com/uploads/fKwPSHXi83tLCrkC2kPszZ/UPSELL_TEORIA_DE_LAS_ORGANIZACIONES.png'];
const CHECKOUT_URL = 'https://checkout.rincondigital.shop/cart/52936942813459:1';
const MEGAPACK_CHECKOUT_URL = 'https://checkout.rincondigital.shop/cart/52936956412179:1';
const PROYECTO_INTEGRADOR_CHECKOUT_URL = 'https://checkout.rincondigital.shop/cart/52936955232531:1';
const TESTIMONIALS = [{
  name: 'Silvia Martínez',
  age: 45,
  city: 'Córdoba',
  role: 'Docente de Economía y Gestión',
  quote: 'Hace 15 años que doy clases y siempre sufría con Proyecto Organizacional. Los chicos se aburrían y yo me desgastaba. Con este material, por primera vez logré que se enganchen con un proyecto real. Las rúbricas me salvaron la vida a la hora de corregir.'
}, {
  name: 'Javier Rodríguez',
  age: 32,
  city: 'Rosario',
  role: 'Profesor de Secundaria',
  quote: 'Tomé unas horas suplentes y no tenía nada preparado. Compré el pack y al día siguiente entré al aula con todo listo. La planificación anual es excelente, te ordena la cabeza y las clases tienen un hilo conductor lógico.'
}, {
  name: 'Andrea Fernández',
  age: 51,
  city: 'Buenos Aires',
  role: 'Jefa de Departamento Contable',
  quote: 'Lo que más valoro es que está adaptado a nuestra realidad. No son teorías de libros yanquis, son problemas y casos que los chicos ven en Argentina. El módulo de costos e ingresos es clarísimo para explicar sin ser contadora.'
}, {
  name: 'Lucas Méndez',
  age: 29,
  city: 'La Plata',
  role: 'Docente Nivel Medio',
  quote: 'Recién arranco en la docencia y me sentía muy perdido. Este material me dio la seguridad que necesitaba. Los alumnos piensan que tengo años de experiencia por lo organizadas que son mis clases. Vale cada peso.'
}, {
  name: 'Gabriela Sosa',
  age: 38,
  city: 'Mendoza',
  role: 'Profesora de Administración',
  quote: "El 'GPS pedagógico' es real. Sabés exactamente dónde estás y hacia dónde vas. Terminé el año con todos los grupos presentando proyectos viables y bien armados. Nunca había logrado ese nivel de producción en el aula."
}];
const MODULES = [{
  title: 'Introducción al Proyecto Organizacional',
  desc: 'Qué es un proyecto, para qué sirve, cómo se trabaja. Lenguaje claro, directo, adolescente.',
  icon: BookOpen
}, {
  title: 'Idea y oportunidad',
  desc: 'Detección de problemas reales. Necesidades del entorno. Ideas cercanas a la vida del alumno.',
  icon: Target
}, {
  title: 'Análisis del entorno',
  desc: 'Entorno social, económico y escolar. Sin tecnicismos innecesarios.',
  icon: Users
}, {
  title: 'Objetivos del proyecto',
  desc: 'Objetivos generales y específicos. Cómo pensarlos y redactarlos correctamente.',
  icon: Check
}, {
  title: 'Organización del equipo',
  desc: 'Roles, tareas y responsabilidades. Trabajo grupal bien guiado.',
  icon: Users
}, {
  title: 'Planificación',
  desc: 'Cronograma simple. Etapas claras. Orden sin complejidad.',
  icon: Calendar
}, {
  title: 'Recursos',
  desc: 'Humanos, materiales y financieros. Adaptados al nivel secundario.',
  icon: Award
}, {
  title: 'Costos e ingresos',
  desc: 'Conceptos básicos. Sin fórmulas complicadas. Aplicado a proyectos simples y reales.',
  icon: DollarSign
}, {
  title: 'Producción / ejecución',
  desc: 'Desarrollo paso a paso del proyecto. Seguimiento claro.',
  icon: Clock
}, {
  title: 'Comunicación del proyecto',
  desc: 'Presentación, informe y defensa oral.',
  icon: MessageCircle
}, {
  title: 'Evaluación y cierre',
  desc: 'Resultados, mejoras y reflexión final.',
  icon: ShieldCheck
}];
export function App() {
  const scrollToPurchase = () => {
    const element = document.getElementById('purchase');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900 selection:bg-emerald-200" data-id="element-0">
      <PurchasePopup data-id="element-1" />

      {/* HERO SECTION */}
      <header className="bg-[#0f3460] text-white pt-12 pb-20 px-4 md:px-8 relative overflow-hidden" data-id="element-2">
        <div className="absolute top-0 left-0 w-full h-full opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-3"></div>
        <div className="max-w-6xl mx-auto relative z-10" data-id="element-4">
          <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-5">
            <div className="flex-1 text-center md:text-left" data-id="element-6">
              <div className="inline-block bg-emerald-500 text-white text-xs font-bold px-3 py-1 rounded-full mb-6 tracking-wide uppercase" data-id="element-7">
                Secundario Comercial / Economía – Argentina
              </div>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-6" data-id="element-8">
                PROYECTO <br data-id="element-9" />
                <span className="text-emerald-400" data-id="element-10">ORGANIZACIONAL 360</span>
              </h1>
              <p className="text-xl md:text-2xl text-slate-200 mb-8 font-light" data-id="element-11">
                Clases listas para todo el año. <br data-id="element-12" />
                <span className="font-medium text-white" data-id="element-13">
                  Sin improvisar, sin estrés y sin llevarte trabajo a casa.
                </span>
              </p>
              <button onClick={scrollToPurchase} className="bg-emerald-500 hover:bg-emerald-400 text-white text-lg font-bold py-4 px-8 rounded-lg shadow-lg hover:shadow-emerald-500/30 transition-all transform hover:-translate-y-1 flex items-center gap-2 mx-auto md:mx-0" data-id="element-14">
                QUIERO MIS CLASES LISTAS
                <ArrowRight className="w-5 h-5" data-id="element-15" />
              </button>
            </div>
            <div className="flex-1 w-full max-w-md md:max-w-full" data-id="element-16">
              <img src={MAIN_IMAGE} alt="Proyecto Organizacional 360 Cover" className="w-full h-auto rounded-xl shadow-2xl transform rotate-2 hover:rotate-0 transition-transform duration-500 cursor-pointer border-4 border-white/10" onClick={scrollToPurchase} data-id="element-17" />
            </div>
          </div>
        </div>

        {/* Wave divider */}
        <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none" data-id="element-18">
          <svg className="relative block w-[calc(100%+1.3px)] h-[50px]" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-19">
            <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" fill="#f8fafc" data-id="element-20"></path>
          </svg>
        </div>
      </header>

      {/* PAIN POINTS SECTION */}
      <section className="py-20 px-4 md:px-8 bg-slate-50" data-id="element-21">
        <div className="max-w-4xl mx-auto" data-id="element-22">
          <div className="text-center mb-12" data-id="element-23">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-4" data-id="element-24">
              Si sos docente de Proyecto Organizacional y cada año sentís que
              vas apagando incendios…
            </h2>
            <p className="text-xl text-slate-600 font-medium" data-id="element-25">
              esto es para vos.
            </p>
          </div>

          <div className="bg-white p-8 md:p-10 rounded-2xl shadow-sm border border-slate-100 mb-12" data-id="element-26">
            <p className="text-lg text-slate-700 mb-6" data-id="element-27">
              Porque el problema no es tu capacidad. No es tu compromiso. Y
              definitivamente no es tu vocación.
            </p>
            <p className="text-lg text-slate-700 font-semibold mb-8" data-id="element-28">
              El problema es que nadie te dio un sistema claro para enseñar
              Proyecto Organizacional sin improvisar, sin estresarte y sin
              llevarte trabajo todos los días a casa.
            </p>

            <div className="space-y-4 bg-red-50 p-6 rounded-xl border border-red-100" data-id="element-29">
              <h3 className="font-bold text-red-800 mb-2 flex items-center gap-2" data-id="element-30">
                <AlertCircle className="w-5 h-5" data-id="element-31" />
                La realidad que muchos docentes no dicen en voz alta:
              </h3>
              <ul className="space-y-3" data-id="element-32">
                {['El programa está claro… pero no cómo bajarlo al aula', 'Sabés que hay que trabajar proyectos, pero no cómo ordenarlos durante todo el año', 'Las clases se arman "sobre la marcha"', 'Los alumnos se pierden', 'Aparece la pregunta incómoda: "Profe… ¿esto para qué sirve?"'].map((item, i) => <li key={i} className="flex items-start gap-3 text-slate-700" data-id="element-33">
                    <span className="text-red-400 mt-1" data-id="element-34">✕</span>
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="text-center max-w-2xl mx-auto" data-id="element-35">
            <p className="text-lg text-slate-700 mb-6" data-id="element-36">
              Y ahí empieza el desgaste. Porque vos sí sabés que la materia es
              importante. Porque sí querés que aprendan. Pero el tiempo no
              alcanza. La energía tampoco.
            </p>
            <p className="text-xl font-bold text-slate-900" data-id="element-37">
              Y terminás sobreviviendo clase a clase.
            </p>
          </div>
        </div>
      </section>

      {/* SOLUTION INTRO */}
      <section className="py-20 px-4 md:px-8 bg-emerald-900 text-white relative overflow-hidden" data-id="element-38">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/diagmonds-light.png')] opacity-10" data-id="element-39"></div>
        <div className="max-w-5xl mx-auto relative z-10 text-center" data-id="element-40">
          <h2 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-41">
            El problema no es Proyecto Organizacional.
            <br data-id="element-42" />
            <span className="text-emerald-400" data-id="element-43">
              El problema es cómo nos obligaron a enseñarlo.
            </span>
          </h2>

          <div className="grid md:grid-cols-2 gap-12 items-center mt-12 text-left" data-id="element-44">
            <div className="bg-white/10 backdrop-blur-sm p-8 rounded-xl border border-white/20" data-id="element-45">
              <h3 className="text-xl font-bold text-emerald-300 mb-4" data-id="element-46">
                Debería ser...
              </h3>
              <ul className="space-y-3" data-id="element-47">
                {['Problemas reales', 'Ideas concretas', 'Trabajo en equipo', 'Planificación', 'Toma de decisiones'].map((item, i) => <li key={i} className="flex items-center gap-2" data-id="element-48">
                    <Check className="w-5 h-5 text-emerald-400" data-id="element-49" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="bg-red-900/20 backdrop-blur-sm p-8 rounded-xl border border-red-500/30" data-id="element-50">
              <h3 className="text-xl font-bold text-red-300 mb-4" data-id="element-51">
                Pero suele ser...
              </h3>
              <ul className="space-y-3" data-id="element-52">
                {['Contenidos sueltos', 'Actividades sin hilo', 'Proyectos que no se terminan', 'Evaluaciones confusas', 'Docentes agotados'].map((item, i) => <li key={i} className="flex items-center gap-2 text-slate-200" data-id="element-53">
                    <span className="text-red-400" data-id="element-54">✕</span>
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="mt-16 bg-white text-slate-900 p-8 md:p-12 rounded-2xl shadow-2xl" data-id="element-55">
            <p className="text-lg text-slate-600 uppercase tracking-widest font-bold mb-2" data-id="element-56">
              Presentamos
            </p>
            <h3 className="text-4xl md:text-6xl font-black text-[#0f3460] mb-6" data-id="element-57">
              PROYECTO
              <br data-id="element-58" />
              ORGANIZACIONAL 360
            </h3>
            <p className="text-xl md:text-2xl text-slate-700 mb-8 max-w-3xl mx-auto" data-id="element-59">
              Un sistema completo de{' '}
              <span className="font-bold text-emerald-600" data-id="element-60">
                clases listas para todo el año
              </span>
              , diseñado específicamente para docentes de Secundario Comercial /
              Economía en Argentina.
            </p>
            <div className="flex flex-col md:flex-row justify-center gap-4" data-id="element-61">
              <div className="flex items-center gap-2 bg-slate-100 px-4 py-2 rounded-lg" data-id="element-62">
                <Check className="w-5 h-5 text-emerald-600" data-id="element-63" />
                <span data-id="element-64">PDF + Word editable</span>
              </div>
              <div className="flex items-center gap-2 bg-slate-100 px-4 py-2 rounded-lg" data-id="element-65">
                <Check className="w-5 h-5 text-emerald-600" data-id="element-66" />
                <span data-id="element-67">De marzo a diciembre</span>
              </div>
              <div className="flex items-center gap-2 bg-slate-100 px-4 py-2 rounded-lg" data-id="element-68">
                <Check className="w-5 h-5 text-emerald-600" data-id="element-69" />
                <span data-id="element-70">Adaptado a Argentina</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* WHAT'S INCLUDED */}
      <section className="py-20 px-4 md:px-8 bg-white" data-id="element-71">
        <div className="max-w-6xl mx-auto" data-id="element-72">
          <div className="text-center mb-16" data-id="element-73">
            <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-6" data-id="element-74">
              Qué incluye, de verdad
            </h2>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto" data-id="element-75">
              Un recorrido completo, ordenado de menor a mayor complejidad, que
              acompaña al alumno y al docente durante todo el año.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-76">
            {MODULES.map((module, idx) => <div key={idx} className="bg-slate-50 p-6 rounded-xl border border-slate-100 hover:border-emerald-200 hover:shadow-md transition-all group" data-id="element-77">
                <div className="bg-white w-12 h-12 rounded-lg flex items-center justify-center shadow-sm mb-4 group-hover:bg-emerald-500 transition-colors" data-id="element-78">
                  <module.icon className="w-6 h-6 text-emerald-600 group-hover:text-white transition-colors" data-id="element-79" />
                </div>
                <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-80">
                  {module.title}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed" data-id="element-81">
                  {module.desc}
                </p>
              </div>)}
          </div>

          <div className="mt-16 bg-slate-900 text-white p-8 rounded-2xl text-center" data-id="element-82">
            <h3 className="text-2xl font-bold mb-6" data-id="element-83">
              Cada clase está pensada para el aula real
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-id="element-84">
              {['Apertura guiada', 'Desarrollo claro', 'Actividad práctica', 'Consigna clara', 'Aplicación real', 'Cierre sugerido'].map((item, i) => <div key={i} className="flex flex-col items-center gap-2" data-id="element-85">
                  <div className="w-8 h-8 rounded-full bg-emerald-500 flex items-center justify-center" data-id="element-86">
                    <Check className="w-5 h-5 text-white" data-id="element-87" />
                  </div>
                  <span className="text-sm font-medium" data-id="element-88">{item}</span>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* BONUSES SECTION */}
      <section className="py-20 px-4 md:px-8 bg-gradient-to-b from-emerald-50 to-white" data-id="element-89">
        <div className="max-w-6xl mx-auto" data-id="element-90">
          <div className="text-center mb-12" data-id="element-91">
            <span className="bg-red-500 text-white font-bold px-4 py-1 rounded-full text-sm uppercase tracking-wider animate-pulse" data-id="element-92">
              Gratis por hoy
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mt-6 mb-4" data-id="element-93">
              Bonos Exclusivos
            </h2>
            <p className="text-xl text-slate-600" data-id="element-94">
              Llevate estas herramientas extra para potenciar tu año
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-start" data-id="element-95">
            <div className="group cursor-pointer" onClick={scrollToPurchase} data-id="element-96">
              <div className="relative overflow-hidden rounded-xl shadow-xl mb-6 bg-white p-2 border border-slate-200 transform transition-transform group-hover:-translate-y-2" data-id="element-97">
                <img src={BONUS_1_IMAGE} alt="Mapa Anual" className="w-full h-auto rounded-lg" data-id="element-98" />
                <div className="absolute top-4 right-4 bg-emerald-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg" data-id="element-99">
                  BONO #1
                </div>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-2 group-hover:text-emerald-600 transition-colors" data-id="element-100">
                Mapa Anual del Proyecto
              </h3>
              <p className="text-slate-600" data-id="element-101">
                Tu GPS para todo el ciclo lectivo. Sabé exactamente qué dar,
                cuándo y cómo. Visualizá todo el año en una sola hoja.
              </p>
            </div>

            <div className="group cursor-pointer" onClick={scrollToPurchase} data-id="element-102">
              <div className="relative overflow-hidden rounded-xl shadow-xl mb-6 bg-white p-2 border border-slate-200 transform transition-transform group-hover:-translate-y-2" data-id="element-103">
                <img src={BONUS_2_IMAGE} alt="Evaluaciones y Rúbricas" className="w-full h-auto rounded-lg" data-id="element-104" />
                <div className="absolute top-4 right-4 bg-emerald-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg" data-id="element-105">
                  BONO #2
                </div>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-2 group-hover:text-emerald-600 transition-colors" data-id="element-106">
                Evaluaciones + Rúbricas
              </h3>
              <p className="text-slate-600" data-id="element-107">
                Evaluá con confianza. Rúbricas detalladas para cada etapa del
                proyecto y evaluaciones prácticas listas para usar.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* FINAL CTA / PRICING */}
      <section id="purchase" className="py-24 px-4 md:px-8 bg-[#0f3460] text-white relative overflow-hidden" data-id="element-108">
        {/* Background elements */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-emerald-500/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-109"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-blue-500/20 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-110"></div>

        <div className="max-w-6xl mx-auto relative z-10" data-id="element-111">
          <h2 className="text-3xl md:text-5xl font-bold mb-6 text-center" data-id="element-112">
            Empezá el próximo ciclo lectivo con todo bajo control
          </h2>
          <p className="text-xl text-slate-300 mb-12 max-w-2xl mx-auto text-center" data-id="element-113">
            Si querés dejar de improvisar. Si querés enseñar con seguridad. Si
            querés tener todo el año resuelto.
          </p>

          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-114">
            {/* ORIGINAL PRODUCT */}
            <div className="bg-white text-slate-900 rounded-3xl p-8 shadow-2xl border-4 border-emerald-500/50 flex flex-col" data-id="element-115">
              <div className="mb-6" data-id="element-116">
                <img src={MAIN_IMAGE} alt="Proyecto Organizacional 360" className="w-full h-auto rounded-xl shadow-lg" data-id="element-117" />
              </div>

              <div className="text-sm font-bold text-slate-500 uppercase tracking-widest mb-2 text-center" data-id="element-118">
                Oferta Especial
              </div>
              <div className="flex items-center justify-center gap-2 mb-6" data-id="element-119">
                <span className="text-5xl md:text-6xl font-black text-[#0f3460]" data-id="element-120">
                  $19.990
                </span>
                <span className="text-xl font-medium text-slate-400 self-end mb-2" data-id="element-121">
                  ARS
                </span>
              </div>

              <div className="space-y-4 mb-8 text-left flex-grow" data-id="element-122">
                <div className="flex items-center gap-3" data-id="element-123">
                  <div className="bg-emerald-100 p-1 rounded-full shrink-0" data-id="element-124">
                    <Check className="w-4 h-4 text-emerald-600" data-id="element-125" />
                  </div>
                  <span className="font-medium" data-id="element-126">
                    Pack completo Proyecto Organizacional 360
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-127">
                  <div className="bg-emerald-100 p-1 rounded-full shrink-0" data-id="element-128">
                    <Check className="w-4 h-4 text-emerald-600" data-id="element-129" />
                  </div>
                  <span className="font-medium" data-id="element-130">
                    Archivos PDF + Word Editable
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-131">
                  <div className="bg-emerald-100 p-1 rounded-full shrink-0" data-id="element-132">
                    <Check className="w-4 h-4 text-emerald-600" data-id="element-133" />
                  </div>
                  <span className="font-medium" data-id="element-134">Bono 1: Mapa Anual</span>
                </div>
                <div className="flex items-center gap-3" data-id="element-135">
                  <div className="bg-emerald-100 p-1 rounded-full shrink-0" data-id="element-136">
                    <Check className="w-4 h-4 text-emerald-600" data-id="element-137" />
                  </div>
                  <span className="font-medium" data-id="element-138">
                    Bono 2: Evaluaciones y Rúbricas
                  </span>
                </div>
              </div>

              <button onClick={() => window.location.href = CHECKOUT_URL} className="w-full bg-emerald-600 hover:bg-emerald-500 text-white text-xl font-bold py-5 px-8 rounded-xl shadow-lg hover:shadow-emerald-500/40 transition-all transform hover:-translate-y-1 flex items-center justify-center gap-2 mb-4" data-id="element-139">
                ACCEDER AHORA
                <ArrowRight className="w-6 h-6" data-id="element-140" />
              </button>

              <p className="text-xs text-slate-500 flex items-center justify-center gap-1" data-id="element-141">
                <ShieldCheck className="w-4 h-4" data-id="element-142" />
                Pago único. Acceso inmediato. Compra segura.
              </p>
            </div>

            {/* PROYECTO INTEGRADOR UPSELL */}
            <div className="bg-gradient-to-br from-blue-50 to-cyan-50 text-slate-900 rounded-3xl p-8 shadow-2xl border-4 border-blue-400 relative overflow-hidden flex flex-col" data-id="element-143">
              {/* Premium badge */}
              <div className="absolute top-0 right-0 bg-gradient-to-r from-blue-500 to-cyan-500 text-white px-6 py-2 rounded-bl-2xl font-bold text-sm flex items-center gap-2 shadow-lg" data-id="element-144">
                <Award className="w-4 h-4" data-id="element-145" />
                PREMIUM
              </div>

              <div className="mb-6 mt-8" data-id="element-146">
                <ImageCarousel images={PROYECTO_INTEGRADOR_IMAGES} data-id="element-147" />
              </div>

              <h3 className="text-xl md:text-2xl font-black text-center mb-4 text-[#0f3460] leading-tight" data-id="element-148">
                PROYECTO INTEGRADOR EMPRESA REAL DE BARRIO
              </h3>

              <div className="text-center mb-6" data-id="element-149">
                <div className="flex items-center justify-center gap-3 mb-2" data-id="element-150">
                  <span className="text-2xl font-bold text-slate-400 line-through" data-id="element-151">
                    $59.990
                  </span>
                  <span className="bg-red-500 text-white text-xs font-bold px-2 py-1 rounded" data-id="element-152">
                    -55%
                  </span>
                </div>
                <div className="flex items-center justify-center gap-2" data-id="element-153">
                  <span className="text-5xl md:text-6xl font-black text-blue-600" data-id="element-154">
                    $26.990
                  </span>
                  <span className="text-xl font-medium text-slate-400 self-end mb-2" data-id="element-155">
                    ARS
                  </span>
                </div>
              </div>

              <div className="space-y-3 mb-8 text-left flex-grow" data-id="element-156">
                <div className="flex items-start gap-3" data-id="element-157">
                  <div className="bg-blue-100 p-1 rounded-full shrink-0 mt-0.5" data-id="element-158">
                    <Check className="w-4 h-4 text-blue-600" data-id="element-159" />
                  </div>
                  <span className="font-semibold text-sm" data-id="element-160">
                    Proyecto completo de empresa de barrio
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-161">
                  <div className="bg-blue-100 p-1 rounded-full shrink-0 mt-0.5" data-id="element-162">
                    <Check className="w-4 h-4 text-blue-600" data-id="element-163" />
                  </div>
                  <span className="font-semibold text-sm" data-id="element-164">
                    Guía paso a paso para alumnos
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-165">
                  <div className="bg-blue-100 p-1 rounded-full shrink-0 mt-0.5" data-id="element-166">
                    <Check className="w-4 h-4 text-blue-600" data-id="element-167" />
                  </div>
                  <span className="font-semibold text-sm" data-id="element-168">
                    Roles definidos y consignas claras
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-169">
                  <div className="bg-blue-100 p-1 rounded-full shrink-0 mt-0.5" data-id="element-170">
                    <Check className="w-4 h-4 text-blue-600" data-id="element-171" />
                  </div>
                  <span className="font-semibold text-sm" data-id="element-172">
                    Rúbrica final de evaluación
                  </span>
                </div>
                <div className="mt-4 pt-4 border-t border-blue-200" data-id="element-173">
                  <p className="text-xs text-slate-600 italic" data-id="element-174">
                    Perfecto para cerrar el año sin improvisar
                  </p>
                </div>
              </div>

              <button onClick={() => window.location.href = PROYECTO_INTEGRADOR_CHECKOUT_URL} className="w-full bg-gradient-to-r from-blue-500 to-cyan-500 hover:from-blue-400 hover:to-cyan-400 text-white text-xl font-bold py-5 px-8 rounded-xl shadow-lg hover:shadow-blue-500/40 transition-all transform hover:-translate-y-1 flex items-center justify-center gap-2 mb-4" data-id="element-175">
                QUIERO ESTE PACK
                <ArrowRight className="w-6 h-6" data-id="element-176" />
              </button>

              <p className="text-xs text-slate-500 flex items-center justify-center gap-1" data-id="element-177">
                <ShieldCheck className="w-4 h-4" data-id="element-178" />
                Ahorrá $33.000 • Acceso inmediato • Compra segura
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* GUARANTEE SECTION */}
      <section className="py-20 px-4 md:px-8 bg-gradient-to-br from-emerald-50 via-white to-blue-50" data-id="element-179">
        <div className="max-w-4xl mx-auto" data-id="element-180">
          <div className="bg-white rounded-3xl shadow-2xl border-4 border-emerald-400 p-8 md:p-12 relative overflow-hidden" data-id="element-181">
            {/* Decorative elements */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-emerald-100 rounded-full blur-3xl opacity-30 -translate-y-1/2 translate-x-1/2" data-id="element-182"></div>
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-blue-100 rounded-full blur-3xl opacity-30 translate-y-1/2 -translate-x-1/2" data-id="element-183"></div>

            <div className="relative z-10 text-center" data-id="element-184">
              {/* Shield icon */}
              <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-emerald-500 to-emerald-600 rounded-full shadow-lg mb-6" data-id="element-185">
                <ShieldCheck className="w-10 h-10 text-white" data-id="element-186" />
              </div>

              <h2 className="text-3xl md:text-4xl font-black text-slate-900 mb-6" data-id="element-187">
                Garantía sin vueltas
              </h2>

              <div className="max-w-2xl mx-auto space-y-6" data-id="element-188">
                <p className="text-lg md:text-xl text-slate-700 leading-relaxed" data-id="element-189">
                  Estamos tan seguros de que este Programa te va a encantar, que
                  si no es así,{' '}
                  <span className="font-bold text-emerald-600" data-id="element-190">
                    te devolvemos el 100% de tu dinero.
                  </span>
                </p>

                <div className="bg-gradient-to-r from-emerald-50 to-blue-50 rounded-2xl p-6 border-2 border-emerald-200" data-id="element-191">
                  <p className="text-lg text-slate-800 font-semibold mb-2" data-id="element-192">
                    Tenés 7 días para probarlo sin riesgo.
                  </p>
                  <p className="text-slate-700" data-id="element-193">
                    Si no te convence, nos escribís y te hacemos el reembolso.{' '}
                    <span className="font-bold" data-id="element-194">Así de simple.</span>
                  </p>
                </div>

                <div className="flex items-center justify-center gap-8 pt-6 flex-wrap" data-id="element-195">
                  <div className="flex items-center gap-2 text-emerald-600" data-id="element-196">
                    <Check className="w-6 h-6" data-id="element-197" />
                    <span className="font-semibold" data-id="element-198">100% Garantizado</span>
                  </div>
                  <div className="flex items-center gap-2 text-emerald-600" data-id="element-199">
                    <Check className="w-6 h-6" data-id="element-200" />
                    <span className="font-semibold" data-id="element-201">7 días de prueba</span>
                  </div>
                  <div className="flex items-center gap-2 text-emerald-600" data-id="element-202">
                    <Check className="w-6 h-6" data-id="element-203" />
                    <span className="font-semibold" data-id="element-204">Reembolso total</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-20 px-4 md:px-8 bg-slate-50" data-id="element-205">
        <div className="max-w-6xl mx-auto" data-id="element-206">
          <div className="text-center mb-16" data-id="element-207">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-208">
              Lo que dicen otros docentes
            </h2>
            <p className="text-xl text-slate-600" data-id="element-209">
              Colegas de todo el país ya están usando el método 360
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-210">
            {TESTIMONIALS.map((t, i) => <div key={i} className={i === 3 || i === 4 ? 'lg:col-span-1.5 md:col-span-1' : ''} data-id="element-211">
                <TestimonialCard {...t} data-id="element-212" />
              </div>)}
          </div>
        </div>
      </section>

      <FAQSection data-id="element-213" />

      <footer className="bg-slate-900 text-slate-400 py-12 px-4 text-center text-sm border-t border-slate-800" data-id="element-214">
        <p data-id="element-215">
          © {new Date().getFullYear()} Rincón Digital. Todos los derechos
          reservados.
        </p>
        <p className="mt-2" data-id="element-216">Hecho con ❤️ para docentes argentinos.</p>
      </footer>
    </div>;
}